import { Container, Center, Box } from "@chakra-ui/react"

import useAdminHolidays from "hooks/useAdminHolidays"
import { useUI } from "providers/UIProvider"

import { IAddEditHolidayModalTypes } from "./AddEditHolidayModalTypes"
import CompanyBranchesForHolidays from "components/shared/CompanyBranches/CompanyBranchesForHolidays"
import Modal from "components/UI/organisms/Modal"
import AdminHolidayForm from "./AdminHolidayForm"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import { IAdminLaundryHoliday } from "types/laundry"

const AddAdminEditHolidayModal: React.FC<IAddEditHolidayModalTypes> = () => {
  const { modals, toggleModal, T } = useUI()
  const laundryHolidayData: IAdminLaundryHoliday = modals.addAdminEditHolidayModal.data

  const {
    form: { values, errors, handleSubmit, resetForm }, handleDateChange, handleTimeChange
  } = useAdminHolidays(laundryHolidayData || null)
  const handleClose = () => {
    toggleModal("addAdminEditHolidayModal", false)
    resetForm()
  }

  return (
    <Modal
      isOpen={modals.addAdminEditHolidayModal.isOpened}
      onClose={handleClose}
      title={T("დასვენების დღის დამატება")}
      styles={{
        headerPadding: "15px 15px 15px 25px",
        bodyPadding: "25px 13px",
        width: "640px",
      }}
      blockScrollOnMount={false}
    >
      <Container padding="0 10px" height="md">
        {/* <Text fontSize="xl">{T("general.holiday.choose_dates")}</Text> */}
        <Center>
          <CompanyBranchesForHolidays width="350px" />
        </Center>
        <Box mt="40px">
          <AdminHolidayForm
            values={values}
            errors={errors}
            handleTimeChange={handleTimeChange}
            handleDateChange={handleDateChange}
          />
        </Box>
        <Center mt="36px">
          <Button
            text={T("actions.confirm")}
            onClick={handleSubmit}
            variant="success"
            styles={{ width: "280px", height: "80px", fontSize: "xxl" }}
            leftIcon={
              <Icon
                name="confirm"
                iconStyles={{ width: "34px", height: "34px" }}
              />
            }
          />
        </Center>
      </Container>
    </Modal>
  )
}

export default AddAdminEditHolidayModal
